<script setup>
import LeadsFiltersPane from "@/js/components/Campaign/LeadsFiltersPane.vue";
import { ref } from "vue";
import store from "@/js/store";
import { getReasonsToSkip } from "@/js/services/CampaignService";
import { arraysEqualUnordered } from "@/js/helpers/utils";

const props = defineProps({
	pack: {
		type: Object,
		required: true,
	}
});
const emit = defineEmits(["update:pack"]);

const skipLeadConditions = ref([...(props.pack.skipLeadConditions || [])]);
const isSaveDisabled = ref(true)


const changeConditions = (newValue) => {
	isSaveDisabled.value = arraysEqualUnordered([...newValue, "CAMPAIGN_DUPLICATE"], props.pack.skipLeadConditions);
	skipLeadConditions.value = [...newValue];
}

const saveChanges = async () => {
	const updatedPack = await store.dispatch("updateSearchLeadsConfigItem", {
		id: props.pack.id,
		skipLeadConditions: getReasonsToSkip(skipLeadConditions.value)
	});
	emit("update:pack", updatedPack)
};
</script>

<template>
	<div class="leads-filters-edit-wrapper">
		<LeadsFiltersPane
			v-model="skipLeadConditions"
			@input="changeConditions"
		/>

		<div class="leads-filters-edit-wrapper__footer">
			<AsyncButton
				class="btn btn--base btn--auto-w"
				:disabled="isSaveDisabled"
				:async-f="saveChanges"
			>
				Save
			</AsyncButton>
		</div>
	</div>
</template>

<style lang="sass">
.leads-filters-edit-wrapper
	&__
		&footer
			display: flex
			align-items: center
			justify-content: flex-end
			gap: 8px
			margin-top: 18px
</style>
